import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { captureCrmLogin } from './app/modules/shared/services/local-storage.service';

captureCrmLogin();

if (environment.production) {
  Sentry.init({
    dsn: "https://4fae4ea2955b4bd4a111477f4f1e8e3d@o1266769.ingest.sentry.io/4504254281744384",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 0,
    tracePropagationTargets: ["localhost", /^https:\/\/fodimi\.pl\/api_user/, /https:\/\/([a-z0-9]+[.])*order[.]fodimi[.]pl/gm],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });

  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
